import { user as defaultState } from '../config/defaultState.mjs';
// Internal Imports
import {
  FETCH_USER_ERRORED,
  FETCH_USER_REQUESTED,
  FETCH_USER_SUCCEEDED,
} from '../config/types/action.mjs';

// Local Functions
function userReducer(state = defaultState, { payload, type } = {}) {
  switch (type) {
    case FETCH_USER_ERRORED:
      return {
        ...state,
        error: payload,
        isLoading: false,
      };
    case FETCH_USER_REQUESTED:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_USER_SUCCEEDED:
      return {
        ...state,
        error: undefined,
        isLoading: false,
        remoteData: payload,
      };
    default:
      return state;
  }
}

// Module Exports
export { userReducer };
